import {
  ASSIGN_TO,
  ASSIGNED_USER_ID,
  ASSIGNED_USER_NAME,
  TEAM,
  ASSIGNED_USER_ID_INITIAL_VALUE,
  ASSIGNED_USER_NAME_INITIAL_VALUE,
  ASSIGN_TO_INITIAL_VALUE,
  TEAM_INITIAL_VALUE,
  PRIORITY,
  START_DATE,
  START_DATE_INITIAL_VALUE,
  DUE_DATE,
  DUE_DATE_INITIAL_VALUE,
  START_DUE_DATE_RANGE,
} from './base';
import {
  RECORD_LINKAGE,
  RECORD_LINKAGE_INITIAL_VALUES,
} from './record-linkage';

export const TASK_MODULE_NAME = 'task';

const INDEXES = [
  'taskName',
  'teamName',
  'linkedRecord',
];

export const TASK_SEARCHABLE_INDEXES = [
  {
    labelId: 'ui-task-list.search.all',
    value: '',
  },
  ...INDEXES.map(index => ({
    labelId: `ui-task-list.task.search.${index}`,
    value: index,
  })),
];

export const TASK_STATUS = {
  CREATED: 'created',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  BLOCKED: 'blocked',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  ON_HOLD: 'on_hold',
};

export const TASK_STATUS_INITIAL_VALUES = [];
export const TASK_PRIORITY_INITIAL_VALUES = [];

export const TASK_FIELDS = {
  ID: 'id',
  NAME: 'name',
  ASSIGN_TO,
  ASSIGNED_USER_NAME,
  ASSIGNED_USER_ID,
  TEAM,
  PRIORITY: 'priority',
  STATUS: 'status',
  START_DUE_DATE_RANGE,
  START_DATE,
  DUE_DATE,
  DESCRIPTION: 'description',
  METADATA: 'metadata',
  JOB: 'job',
  JOB_ID: 'jobId',
  RECORD_LINKAGE,
};

export const TASK_INITIAL_VALUES = {
  [TASK_FIELDS.NAME]: '',
  [TASK_FIELDS.ASSIGNED_USER_NAME]: ASSIGNED_USER_NAME_INITIAL_VALUE,
  [TASK_FIELDS.ASSIGNED_USER_ID]: ASSIGNED_USER_ID_INITIAL_VALUE,
  [TASK_FIELDS.TEAM]: TEAM_INITIAL_VALUE,
  [TASK_FIELDS.ASSIGN_TO]: ASSIGN_TO_INITIAL_VALUE,
  [TASK_FIELDS.PRIORITY]: PRIORITY.LOW,
  [TASK_FIELDS.STATUS]: TASK_STATUS.CREATED,
  [TASK_FIELDS.START_DATE]: START_DATE_INITIAL_VALUE,
  [TASK_FIELDS.DUE_DATE]: DUE_DATE_INITIAL_VALUE,
  [TASK_FIELDS.DESCRIPTION]: '',
  [TASK_FIELDS.METADATA]: {},
  [TASK_FIELDS.JOB]: {},
  [TASK_FIELDS.RECORD_LINKAGE]: RECORD_LINKAGE_INITIAL_VALUES,
};

export const TASK_LIST_DEFAULT_SORT_FIELD = TASK_FIELDS.NAME;

export const RESULT_COUNT_INCREMENT = 100;
